import React, { PureComponent, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import handler from '@bit/wavfichacerta.fichacerta.inputs-functions.input-handler';
import { toastr } from 'react-redux-toastr';
import { fetchCEP } from '../../validation/actions';

import { text, select, composed, maskedText, textDisabled, cep } from '@bit/wavfichacerta.fichacerta.inputs.inputs';
import { SubtitleCard } from '../../../components/Customer/customerData.styled';
import { BaseColumn } from '@bit/wavfichacerta.fichacerta.shared-styles.columns';
import { ButtonForm } from '../../../components/shared/formStyles.styled';
import {
  StyledRow,
  FormContentRow
} from '@bit/wavfichacerta.fichacerta.shared-styles.rows';
import Card from '@bit/wavfichacerta.fichacerta.cards.card';
import { getChangedValues } from '../../../utils/formHelper';

import CollapsableContainer from '../../../components/CollapsableContainer';
import {
  identificationFields,
  addressFields,
  aditionalContactsFirstFields,
  aditionalContactsSecondFields
} from './fieldsPF';
import {
  identificationFields as identificationPJ,
  addressFields as addressPJ,
  aditionalContactsFirstFields as aditionalContactsFirstFieldsPJ,
  aditionalContactsSecondFields as aditionalContactsSecondFieldsPJ,
  aditionalContactsThirdFields as aditionalContactsThirdFieldsPJ
} from './fieldsPJ';

import ReactTooltip from 'react-tooltip'
import TourTooltip from '../../../components/shared/TourTooltip';
import { instance as axiosInstance } from './../../../services/axiosInstance';
import ClientGarantias from './ClientGarantias';
import CheckBox from '../../../components/shared/CheckBox';

class CustomerForm extends PureComponent {
  state = {
    dataProducts: [],
    laudoSettings: {}
  }

  static defaultProps = {
    requirements: {}
  }

  componentDidMount() {
    if (this.props.master) {
      this.getAdministrador();
    }
    this.getLaudoSettings();
  }

  redirectToAuth = () => {
    if (this.props.history && typeof this.props.history.push === 'function') {
      this.props.history.push('/auth');
    }
  }

  getLaudoSettings = async () => {
    try {
      const URL = '/api/administrador/configuracoes-laudo/acoes';
      const token = this.props.login.user.token.access_token;
      const headers = {
        'Authorization': `Bearer ${token}`
      };
      const result = await axiosInstance.get(URL, { headers });
      if (result.status === 401) {
        this.redirectToAuth();
        return null;
      }
      const response = result.data;
      this.setState({ laudoSettings: response });
      return response;
    } catch (err) {
      console.log('ERR:', err);
      toastr.error('Solicitação', 'Não foi possível buscar as configurações do laudo.');
      throw err;
    }
  }

  handleLaudoSettingChange = async (key, value) => {
    try {
      const URL = '/api/administrador/configuracoes-laudo/acoes';
      const token = this.props.login.user.token.access_token;
      const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      };
      // Monta novo objeto de configurações, alterando apenas o item modificado
      const current = this.state.laudoSettings.data ? { ...this.state.laudoSettings.data } : { ...this.state.laudoSettings };
      current[key] = value;
      const data = { ...current };
      const result = await axiosInstance.post(URL, { ...data }, { headers });
      if (result.status === 401) {
        this.redirectToAuth();
        return;
      } else if(result.status !== 200) {
        toastr.error('Erro', 'Não foi possível atualizar a configuração.');
        return;
      }
      // Atualiza o estado local após sucesso
      this.setState({ laudoSettings: { data } });
      toastr.success('Configuração atualizada!');
    } catch (err) {
      console.log('ERR:', err);
      toastr.error('Erro', 'Não foi possível atualizar a configuração.');
    }
  }

  getAdministrador = async () => {
    try {
      const URL = '/api/administrador?relations=true&information=true'

      const token = this.props.login.user.token.access_token

      const headers = {
        'Authorization': `Bearer ${token}`
      }

      const result = await axiosInstance.get(URL, {headers});
      if(result.status === 401) {
        this.redirectToAuth();
        return null;
      }
      const response = result.data.data;
      const cliente = response?.cliente ?? {};
      const produtos_disponiveis_usuario_adicional = cliente.produtos_adicionais ?? [];
      const produtos_habilitados_cliente = cliente.produtos_habilitados ?? [];
      const cliente_tem_fccompletaPF = produtos_habilitados_cliente.some((item) => item.id === 7)
      const cliente_tem_fccompletaPJ = produtos_habilitados_cliente.some((item) => item.id === 8)
      let products = (response?.information?.produtos ?? []).map(product => {
        return {
          id: product.id,
          titulo: product.titulo,
          checked: produtos_disponiveis_usuario_adicional.some((item) => item.id === product.id),
        }
      })
      if(!cliente_tem_fccompletaPF) {
        products = products.filter(item => item.id !== 7)
      }
      if(!cliente_tem_fccompletaPJ) {
        products = products.filter(item => item.id !== 8)
      }
      this.setState({dataProducts: [...products]})
      console.log('productsx1', products)
      return response;
    } catch(err) {
      console.log('ERR:', err)
      throw err
    }
  }

  addProdutoAdicional = async (productId) => {
    try {
      const URL = '/api/administrador/funcionario/produtos-adicionais'

      const token = this.props.login.user.token.access_token

      const headers = {
        'Authorization': `Bearer ${token}`
      }

      let ids = []
      
      this.state.dataProducts.map(product => {
        if(product.checked) {
          ids.push(product.id)
        }
      })

      ids.push(Number(productId))

      const data = {
        produtos: ids
      }

      const result = await axiosInstance.post(URL, data, {headers});
      if(result.status === 401) {
        this.redirectToAuth();
        return null;
      }
      const response = result.data;
      await this.getAdministrador();
      if (result.status !== 200) {
        toastr.error('Solicitação', 'Não foi possível processar a sua solicitação no momento.');
        return;
      }
      
      toastr.success('Sucesso!', response.message);
      return response;
    } catch(err) {
      console.log('ERR:', err)
      toastr.error('Solicitação', 'Não foi possível processar a sua solicitação no momento.');
      throw err
    }
  }

  deleteProdutoAdicional = async (productId) => {
    try {
      const URL = '/api/administrador/funcionario/produtos-adicionais'

      const token = this.props.login.user.token.access_token

      const headers = {
        'Authorization': `Bearer ${token}`
      }

      const data = {
        produtos: [Number(productId)]
      }

      const result = await axiosInstance.delete(URL, {data, headers});
      if(result.status === 401) {
        this.redirectToAuth();
        return null;
      }
      const response = result.data;
      await this.getAdministrador();
      if (result.status !== 200) {
        toastr.error('Solicitação', 'Não foi possível processar a sua solicitação no momento.');
        return;
      }
      
      toastr.success('Sucesso!', response.message);
      return response;
    } catch(err) {
      console.log('ERR:', err)
      toastr.error('Solicitação', 'Não foi possível processar a sua solicitação no momento.');
      throw err
    }
  }

  renderFields = (fields) => {
    const { requirements } = this.props;
    return fields.map((row, index) => (
      <StyledRow key={row.name} align="flex-start" justify="flex-start" customstyle={`margin-top: ${index > 0? ".5rem": "0"};`}>
        {
          row.fields.map((field) => {
            if (field.type === "select") {
              return handler({ select })({ ...field, options: requirements[field.name] });
            } else if (field.type === "cep") {
              const { fetchCEP } = this.props;
              return handler({ cep })({ ...field, fetchCEP });
            }
            return handler({ text, composed, maskedText, textDisabled })(field);
          })
        }
      </StyledRow>
    ));
  }

  submitForm = () => {
    const { entity, changedValues, initialValues, onSubmitForm } = this.props;
    const formValues = getChangedValues(initialValues, changedValues);
    onSubmitForm(entity, formValues);
  }

  onChange = (e) => {
    const checked = e.target.checked
    const productId = e.target.id
    if(checked) {
      this.addProdutoAdicional(productId)
    } else {
      this.deleteProdutoAdicional(productId)
    }
  }

  getDefaultChecked = (name) => {
    this.state.dataProducts.filter(product => {
      return product.id === 2
    })
  }

  renderFieldsCheckProducts = () => {
    return this.state.dataProducts.map(product => {
      const id = String(product.id);
      return (
        <div className="customer-data-produto-item" key={product.id}>
          <CheckBox
            name={id}
            label={product.titulo}
            checked={product.checked}
            onChange={this.onChange}
            customstyle="width: 100%; white-space: normal;"
          />
        </div>
      );
    });
  }

  renderLaudoSettings = () => {
    const { laudoSettings } = this.state;
    if (!laudoSettings || typeof laudoSettings !== 'object' || Object.keys(laudoSettings).length === 0) {
      return <div style={{ color: '#7f7f7f', fontSize: '0.9rem' }}>Nenhuma configuração encontrada.</div>;
    }
    const settings = laudoSettings.data ? laudoSettings.data : laudoSettings;
    // Layout em colunas, similar ao bloco de produtos
    const entries = Object.entries(settings).filter(([key]) =>
      this.props.master || key !== 'adicionais_podem_configurar_laudo'
    );
    const columns = [entries];

    const acaoLabels = {
      acoes_despejo: 'Ações de Despejo e Locação',
      acoes_criminais: 'Ações Criminais',
      outras_acoes_cnj_reu: 'Outras Ações do CNJ (Réu)',
      outras_acoes_cnj_autor: 'Outras Ações do CNJ (Autor)',
      adicionais_podem_configurar_laudo: 'Usuários Adicionais podem configurar o laudo no momento da geração'
    };

    return (
      <div className="customer-data-laudo-settings">
        {columns.map((col, colIdx) => (
          <div key={colIdx} className="customer-data-laudo-column">
            {col.map(([key, value]) => (
              <div key={key} className="customer-data-laudo-row">
                <CheckBox
                  name={`laudo-setting-${key}`}
                  label={acaoLabels[key] || key.replace(/_/g, ' ')}
                  checked={!!value}
                  onChange={e => this.handleLaudoSettingChange(key, e.target.checked)}
                  customstyle="width: 100%; white-space: normal;"
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  }
  
  render() {
    const { entity, requirements, isSaving, changedValues, initialValues, master } = this.props;
    if (typeof requirements === "object" && Object.keys(requirements).length === 0) {
      return null;
    }
    const formValues = getChangedValues(initialValues, changedValues);
    return (
      <StyledRow margin="3vh 0">
        <BaseColumn>
          <div className="dados-cadastrais">
            <Card className="customer-dc-ident-card" title="Identificação" padding="1rem 1rem 0 1rem">
              <TourTooltip target="tooltip-dados-cadastrais" />
              <CollapsableContainer toggleButtonClassName="customer-dc-collapse-toggle-with-tip">
                <FormContentRow>
                  {entity === "PF"? this.renderFields(identificationFields(master)) : this.renderFields(identificationPJ(master))}
                </FormContentRow>
              </CollapsableContainer>
              <ReactTooltip id="tooltip-dados-cadastrais" place="left" type="dark" effect="float">
                Aqui é possível conferir os dados cadastrais da imobiliária
              </ReactTooltip>
            </Card>
            
            <div className="customer-data-endereco-wrap">
              <Card title="Endereço" padding="1rem 1rem 0 1rem">
                <CollapsableContainer>
                  <FormContentRow>
                    {entity === "PF"? this.renderFields(addressFields(master)) : this.renderFields(addressPJ(master))}
                  </FormContentRow>
                </CollapsableContainer>
              </Card>
            </div>
          </div>

          <Card className="customer-dc-contatos-card" title="Contatos Adicionais" padding="1rem 1rem 0 1rem">
              <TourTooltip target="tooltip-contatos-adicionais" />
              <CollapsableContainer open={false} toggleButtonClassName="customer-dc-collapse-toggle-with-tip">
                <SubtitleCard>| OPERACIONAL</SubtitleCard>
                <FormContentRow>
                  {entity === "PF"? this.renderFields(aditionalContactsFirstFields(master)) : this.renderFields(aditionalContactsFirstFieldsPJ(master))}
                </FormContentRow>

                <SubtitleCard>| FINANCEIRO</SubtitleCard>
                <FormContentRow>
                  {entity === "PF"? this.renderFields(aditionalContactsSecondFields(master)) : this.renderFields(aditionalContactsSecondFieldsPJ(master))}
                </FormContentRow>

                {entity === "PJ" && (
                  <Fragment>
                    <SubtitleCard>| DIRETORIA</SubtitleCard>
                    <FormContentRow>
                      {this.renderFields(aditionalContactsThirdFieldsPJ(master))}
                    </FormContentRow>
                  </Fragment>
                )}
              </CollapsableContainer>
              <ReactTooltip id="tooltip-contatos-adicionais" place="left" type="dark" effect="float">
                Caso precise atualizar os contatos das áreas, acione o nosso suporte.
              </ReactTooltip>
            </Card>

          {master &&
            <>
              <Card title="Produtos do CLIENTE" padding="1rem 1rem 0 1rem">
                <CollapsableContainer>
                  <h6 style={{fontSize: '0.8rem', color: '#7f7f7f', marginBottom: 15}}>Produtos para o usuário ADICIONAL</h6>
                  <div className="customer-data-produtos-wrap">
                    {this.renderFieldsCheckProducts()}
                  </div>
                </CollapsableContainer>
              </Card>
            </>
          }

          {master &&
            <>
              <Card title="Configurações do Laudo" padding="1rem 1rem 0 1rem">
                <CollapsableContainer>
                  <h6 style={{fontSize: '0.8rem', color: '#7f7f7f', marginBottom: 15}}>Ações Judiciais configuradas para o laudo</h6>
                  {this.renderLaudoSettings()}
                </CollapsableContainer>
              </Card>
            </>
          }

          <ClientGarantias canEdit={Boolean(master)} />
        </BaseColumn>
        {/* <StyledRow margin="0 0 2vh 0">
          {master && <ButtonForm onClick={this.submitForm} disabled={isSaving || formValues === null}>Salvar Alterações</ButtonForm>}
        </StyledRow> */}
      </StyledRow>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ fetchCEP }, dispatch);

const mapStateToProps = (state) => ({
  requirements: state.requirements,
  changedValues: state.form.customerForm !== undefined? state.form.customerForm.values : {},
  master: state.login.user.usuario.master,
  isSaving: state.customerData.isSaving,
  login: state.login
});

const Form = reduxForm({
  form: 'customerForm',
  enableReinitialize: true
})(CustomerForm);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form));
